import { useState, useEffect } from 'react';
import { ToggleSwitchWidget } from "../../core/Widgets/ToggleSwitchWidget";
import {  AUTHREQ } from '../../constants/constants';
import { VideoComponentOverlay } from "../../core/Overlays/VideoComponentOverlay";
import { StatusBar } from "../StatusBar/StatusBar";
import { PTZWidget } from "../../core/Widgets/PTZWidget";
import { RealtimeUpdatesProvider } from '../../services/Requests/websocket';
import { RosSocket } from "../../services/Ros/RosSocket";
import { DrivingProvider } from "../../services/Ros/Driving/DrivingProvider";
import { DrivingControls } from "../DrivingControls/DrivingControls";
import { KeyboardShortcutProvider } from "../../services/General/KeyboardShortcutProvider";
import { MapWidget } from '../../core/Widgets/MapWidget';
import { PathPlanningOverlay } from '../PathPlanning/PathPlanningOverlay';
import { StreamSelector } from '../../core/Video/StreamSelector';
import { WarningOverlay } from "../../services/Notifications/WarningOverlay";
import { Subscriber } from "../../services/Ros/Subscriber";
import { ALL_COLLISIONS_TOPIC, BATTERY_TOPIC, ESTOP, STATE, WARN_TOPIC } from "../../constants/topics";
import LightControlButtons from '../StatusBar/LightControlButtons'; // Import the new component
import { RecordingWidget } from '../../core/Widgets/RecordingWidget';
import { SimpleRecordingWidget } from '../../core/Widgets/SimpleRecordingWidget';
// import { RTSPViewer } from '../../services/Video/RTSPViewer';
import WEBRTCVideo from '../../services/Video/WEBRTCVideo';
import { ImageViewerOverlay } from '../ImageVIewer/ImageViewerOverlay';
import { DockingControl } from '../DrivingControls/DockingControl';
import { StopTravelOverlay } from '../ZoneTravel/StopTravelOverlay';
import EmergencyShutdown from '../Emergency/EmergencyShutdown';
import { Publisher } from '../../services/Ros/Publisher';
import { SettingsPageOverlay } from '../SettingsPage/SettingsPageOverlay';
import { EmergencyDrivingControls } from '../DrivingControls/EmergencyDrivingControls';
import { EmergencyModeTicker } from '../Emergency/EmergencyModeTicker';
import { Button} from 'react-bootstrap';
import { CollisionOverlay } from '../../services/Notifications/CollisionOverlay';
import { useAuth } from '../../utilities/http/routing/AuthContext';
// import { WEBRTCViewer}  from '../../services/Video/WEBRTCViewer';
import { useObserver } from '../../utilities/http/routing/ObserverContext';
import { useOperator } from '../../utilities/http/routing/OperatorContext';
import { ToastProvider } from '../../services/Notifications/ToastProvider';
import { BackendToastNotification } from '../BackendToastNotification';
import TeleopToggle from '../DrivingControls/TeleopToggle';
import { ServiceCaller } from '../../services/Ros/ServiceCaller';
import { BatteryWarningOverlay } from '../../services/Notifications/BatteryWarningOverlay';
import { BackendTimeOffsetProvider } from '../../utilities/BackendTimeOffsetProvider ';
import { SpeedControl } from '../DrivingControls/SpeedControl';
import { VideoWidget } from '../../core/Widgets/VideoWidget';
import { ActiveUsersProvider } from '../../utilities/ActiveUsersProvider';
import {ActiveUserDisplay} from '../ActiveUserDisplay';
import MaintenanceShutdown from '../Maintenance/MaintenanceShutdown';
import { useMaintenanceMode } from '../../utilities/http/routing/MaintenanceContext';
import { MaintenanceModeTicker } from '../Maintenance/MaintenanceModeTicker';
import { RouteComponentProps } from 'react-router-dom';
import { useRobotDetails } from '../../utilities/RobotDetailsContext';
import { useFetch } from '../../services/Requests/useFetch';
import { IndoorRecordingWidget } from '../../core/Widgets/IndoorRecordingWidget';
import { CancelControl } from '../DrivingControls/CancelControl';


interface MatchParams {
  robot: string;
}

export type CameraStreams = 'front' | 'rear' | 'ptz' | 'thermal' | 'gas' | 'none'

const options: RequestInit = {
  method: "GET"
}

interface LoadSettings {
  email: string;
  operatorEmail: string;
  imageReportEmail: string;
  activeHours: boolean;
  startTime: string;
  stopTime: string;
  Operating: boolean;
  Maintenance: boolean;
}

const PageB = () => (
  <>
    {/* Add any components you need for PageB */}
  </>
);

export const HomePage: React.FC<RouteComponentProps<MatchParams>> = ({ match }) => {
  const robot = match.params.robot ?? "rotokawa-m2";
  console.log(`THis is the robot ${robot}`)
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [isRecordOn, setIsRecordOn] = useState(false);
  const [isEmergencyOverride, setIsEmergencyOverride] = useState(false);
  const { isObserver } = useObserver();
  const { isOperator, canDrive } = useOperator();
  const { robotDetails } = useRobotDetails()
  const { maintenanceModeEnabled,setMaintenanceModeEnabled, canMaintain } = useMaintenanceMode();
  const { state: loadState, get: loadSettings, abortRequest: loadAbort } = useFetch<LoadSettings>('/api/missions/load_settings', options);
  
  useEffect(() => {
          loadSettings();
          return () => {
              if (loadAbort) {
                  loadAbort();
              }
          };
      }, []);
  
  useEffect(() => {
      const { status, data } = loadState;
      if (status === 'fetched' && data) {
          setMaintenanceModeEnabled(data.Maintenance)
      }
  }, [loadState]);

  const useLogout = () => {
    const { setIsAuthenticated } = useAuth();
  
    const logout = async () => {
      try {
        // Perform logout actions, e.g., call a logout API
        await fetch('/api/logout', { method: 'POST' });
        
        // Clear authentication tokens or session data
        localStorage.removeItem('authToken');
        
        // Update authentication state
        setIsAuthenticated(false);
  
        // Redirect to the logout URL or homepage
        window.location.href = `/${robot}/logout`;
      } catch (error) {
        console.error('Logout failed:', error);
      }
    };
  
    return logout;
  };
  const handleLogout = useLogout();
  


  const [stream, setStream] = useState<CameraStreams>('ptz');

  // console.log(isEmergencyOverride ? 'Collision Override' : 'Regular Driving')
  isEmergencyOverride ? console.log('Collision Override Active') : console.log('Collision Override Inactive')


  const handleToggleChange = () => {
    setIsToggleOn(prev => !prev);
    console.log("Toggled, isToggleOn:", !isToggleOn); // Log state after toggling
  };

  const handleRecordChange = () => {
    setIsRecordOn(prev => !prev);
    console.log("Toggled, isRecordOn:", !isRecordOn); // Log state after toggling
  };

  const updateStream = (stream: CameraStreams) => {
    setStream(stream);
    console.log('stream updated:', stream);
  };

  const activateEmergencyMode = () => {
    setIsEmergencyOverride(true);
    setIsToggleOn(true);
  };

  const deactivateEmergencyMode = () => {
    setIsEmergencyOverride(false);
    setIsToggleOn(false);
  }

  useEffect(() => {
    
    if (isObserver){
      console.log(`Operator is an Observer, unable to Activate Drive`)
      return
    }
    // const pge = isToggleOn ? 'B' : 'A';

    // console.log(pge); // Log state after it has been updated
  }, [isToggleOn]);


  return (
    <>
      <WEBRTCVideo server={robotDetails.webRTCServer} src={stream} />
      <KeyboardShortcutProvider>
        <VideoComponentOverlay>
        <RealtimeUpdatesProvider>
          <RosSocket url={robotDetails.rosWebsocket} autoconnect={true} timeout={5000}>
          {!isObserver && canDrive && <ToggleSwitchWidget labelVal="Manual Mode" isChecked={isToggleOn} onChange={handleToggleChange} disabled={maintenanceModeEnabled} />}
          {!isObserver && canDrive && !maintenanceModeEnabled && <ServiceCaller name='/activate_teleop' type='std_srvs/srv/SetBool' >
            <TeleopToggle activateTeleop={isToggleOn} collisionOveride={isEmergencyOverride}/>
          </ServiceCaller>}
            {!isObserver && isOperator && canDrive && <ToggleSwitchWidget labelVal="Recording" isChecked={isRecordOn} onChange={handleRecordChange} disabled={maintenanceModeEnabled}/>}
            <br/>
            
            <Subscriber name={STATE.name} type={STATE.type} rate={STATE.throttle}>
              <ServiceCaller name="/state_request_service" type="std_srvs/srv/Trigger">
                {(!isObserver && !canDrive || (canMaintain && isObserver && maintenanceModeEnabled)) &&<CancelControl />}
              </ServiceCaller>
            </Subscriber>
            {!maintenanceModeEnabled && isOperator &&
              <Button variant="danger" onClick={isEmergencyOverride ? deactivateEmergencyMode : activateEmergencyMode}>
                {isEmergencyOverride ? 'Deactivate' : 'Activate'}  Collision  Override
              </Button>
            }
            <Publisher name={ESTOP.name} type={ESTOP.type} rate={ESTOP.throttle}>
              <EmergencyShutdown/>
            </Publisher>
            {!isObserver &&<ActiveUsersProvider>
              <ActiveUserDisplay/>
            </ActiveUsersProvider>}
            {maintenanceModeEnabled &&<ServiceCaller name='/gentle_shutdown' type='std_srvs/srv/SetBool' >
              <MaintenanceShutdown/>
            </ServiceCaller>}
            {((stream === 'ptz'|| stream === 'thermal' || stream === 'gas')  &&!isObserver) && <PTZWidget />}
            {((stream === 'ptz'|| stream === 'thermal' || stream === 'gas')  &&!isObserver) && <MapWidget /> }
            {((stream !== 'ptz'&& stream !== 'thermal' && stream !== 'gas')  || isObserver) && <MapWidget position="widget-top-right" />}
            <StreamSelector updateStream={updateStream} />
            {!isObserver && !robotDetails.isIndoor &&<LightControlButtons/>} 
            <Subscriber name={WARN_TOPIC.name} type={WARN_TOPIC.type} rate={WARN_TOPIC.throttle}>
              <WarningOverlay />
            </Subscriber>
            <Subscriber name={BATTERY_TOPIC.name} type={BATTERY_TOPIC.type} rate={BATTERY_TOPIC.throttle}>
              <BatteryWarningOverlay/>
            </Subscriber>
            <StatusBar width="40%" />          
            <></>
            
            <DrivingProvider>
              <BackendTimeOffsetProvider >
                {isToggleOn 
                  ? (isEmergencyOverride 
                      ? <EmergencyDrivingControls /> 
                      : <DrivingControls />) 
                  : <PageB />}
                  {!isObserver && <SpeedControl isManualModeActive={isToggleOn}/>}
                      <PathPlanningOverlay isManualModeActive={isToggleOn}/>   
                      <StopTravelOverlay isManualModeActive={isToggleOn}/>
                      <ToastProvider>
                        <BackendToastNotification/>
                      </ToastProvider>
              </BackendTimeOffsetProvider>
            </DrivingProvider>
            <ImageViewerOverlay/>
            <SettingsPageOverlay/>
            <br/>
            <Subscriber name={STATE.name} type={STATE.type} rate={STATE.throttle}>
              <ServiceCaller name="/state_request_service" type="std_srvs/srv/Trigger">
                {(!isObserver || (canMaintain && isObserver && maintenanceModeEnabled)) &&<DockingControl />}
              </ServiceCaller>
            </Subscriber>
            <Subscriber name={ALL_COLLISIONS_TOPIC.name} type={ALL_COLLISIONS_TOPIC.type} rate={ALL_COLLISIONS_TOPIC.throttle}>
              <CollisionOverlay direction='Rear' stream={stream}/>
            </Subscriber>
             {isRecordOn === true && 
              (robotDetails.isIndoor ? <IndoorRecordingWidget isManualModeActive={isToggleOn}/> : (robotDetails.simpleRec ? <SimpleRecordingWidget isManualModeActive={maintenanceModeEnabled}/> : <RecordingWidget isManualModeActive={isToggleOn} />) )
             }
            {isRecordOn === false && <Subscriber name={STATE.name} type={STATE.type} rate={STATE.throttle}>
              <ServiceCaller name="/state_request_service" type="std_srvs/srv/Trigger">
                <VideoWidget id={stream}/>
              </ServiceCaller>
            </Subscriber>}
          </RosSocket>
          {AUTHREQ && <Button variant="primary" onClick={handleLogout}>
            Disconnect
          </Button>}
          {isEmergencyOverride && <EmergencyModeTicker />}
          {maintenanceModeEnabled && <MaintenanceModeTicker />}
          
          </RealtimeUpdatesProvider>
        </VideoComponentOverlay>
      </KeyboardShortcutProvider>
    </>
  );
};
